export default __webpack_public_path__ + "static/media/paidWithBg.c4842901.png";